import React from 'react'
import PropTypes from 'prop-types'
import styles from './mobile-native-select.module.css'

const MobileNativeSelect = ({ children, disabled, onChange, placeholder, placeholderValue, value, error }) => {
    return (
        <div className={styles['mobile-select-container']}>
            <select
                {...{
                    className: error ? styles['mobile-select-error'] : styles['mobile-select'],
                    disabled,
                    id: 'native-data-select',
                    name: 'native-data-select',
                    onChange,
                    required: true,
                    value
                }}
            >
                <option
                    className={disabled || value === '' ? styles['option-disabled'] : styles['option']}
                    value={placeholderValue}
                    disabled
                    selected
                    hidden
                >
                    {placeholder}
                </option>
                {children.map(item => item)}
            </select>
        </div>
    )
}

MobileNativeSelect.propTypes = {
    disabled: PropTypes.boolean,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    placeholderValue: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.boolean
}

export { MobileNativeSelect }
